import { Card, Col, Row } from "react-bootstrap";
import { ILicenceActionDetails } from "../../../api/ILicensingAction";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import EpaField2Rows from "../../../leap-components/EpaField2Rows";
import { LicenceActionDetailsIcon } from "../../../leap-components/icons/LeapIcons";

interface LicenceActionHeaderProps {
  licenceActionDetails: ILicenceActionDetails;
}

const LicenceActionHeader = ({
  licenceActionDetails,
}: LicenceActionHeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <LicenceActionDetailsIcon />
                  </td>
                  <td>
                    <h2>Licensing Action: {licenceActionDetails.code}</h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows label={"Type"} value={licenceActionDetails.type} />
          </Col>
          <Col className="col-6 col-md-3">
            <EpaField2Rows
              label={"Status"}
              value={licenceActionDetails.status}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default LicenceActionHeader;
